import { gql } from "apollo-angular";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { DELETION_RESPONSE_FRAGMENT } from "./system-definition";

export const PRODUCT_ECOMMERCE_CONFIG_FIELDS_FRAGMENT = gql`
fragment ProductECommerceConfigFields on ProductECommerceConfig {
    ...IBaseModel
    productId
    taxonomyCategoryId
}
${BASEMODEL_FRAGMENT}
`;

export const PRODUCT_ECOMMERCE_CONFIG_FRAGMENT = gql`
fragment ProductECommerceConfig on ProductECommerceConfig {
    ...ProductECommerceConfigFields
}
${PRODUCT_ECOMMERCE_CONFIG_FIELDS_FRAGMENT}
`;

export const GET_PRODUCT_ECOMMERCE_CONFIGS = gql`
query getProductECommerceConfigs($input: ProductECommerceConfigSearchInput) {
    getProductECommerceConfigs(input: $input) {
        totalItems
        items {
            ...ProductECommerceConfig
        }
    }
}
${PRODUCT_ECOMMERCE_CONFIG_FRAGMENT}
`;

export const GET_PRODUCT_ECOMMERCE_CONFIG = gql`
query GetProductECommerceConfig($id: String!) {
    getProductECommerceConfig(id: $id) {
        ...ProductECommerceConfig
    }
}
${PRODUCT_ECOMMERCE_CONFIG_FRAGMENT}
`;

export const SAVE_PRODUCT_ECOMMERCE_CONFIG = gql`
mutation SaveProductECommerceConfig($input: ProductECommerceConfigInput!) {
    saveProductECommerceConfig(input: $input) {
        ...ProductECommerceConfig
    }
}
${PRODUCT_ECOMMERCE_CONFIG_FRAGMENT}
`;

export const DELETE_PRODUCT_ECOMMERCE_CONFIG = gql`
mutation DeleteProductECommerceConfig($id: String!) {
    deleteProductECommerceConfig(id: $id) {
        ...DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;
